import axios from 'axios'
import cookies from 'vue-cookies'

import {apiUrl} from '@/api/base.js'

export default {
    get_group_buy_info(groupBuyId) {
        return axios.get(`${apiUrl}v2/group_buy/${groupBuyId}`)
    },
    validate_group_buy_access(groupBuyId) {
        return axios.get(`${apiUrl}v2/validate_group_buy_access/${groupBuyId}`)
    },
    start_group_buy(args) {
        return axios.post(`${apiUrl}v2/start_group_buy/`,{params: args})
    },
}
